import { MilkmanDeliveryResolver } from "./MilkmanDeliveryResolver";
import { MobiDeliveryResolver } from "./MobiDeliveryResolver";
import { SdaDeliveryResolver } from "./SdaDeliveryResolver";
import { MilkmanFreshFoodDeliveryResolver } from "./MilkmanFreshFoodDeliveryResolver";
import { FoodLogicaDeliveryResolver } from "./FoodLogicaDeliveryResolver";
import { QuomiDeliveryResolver } from "./QuomiDeliveryResolver";

export class DeliveryManager {
  getResolverByName(name) {
    let resolvers = this.getResolvers()
    if (Object.keys(resolvers).indexOf(name) == -1) {
      throw "resolver " + name + " not found. Valid options: [" + Object.keys(resolvers).join(',') + "]"
    }
      return new resolvers[name]();
  }

  getResolvers() {
    return {
      'milkmanfresh': MilkmanFreshFoodDeliveryResolver,
      'foodlogica': FoodLogicaDeliveryResolver,
      'milkman': MilkmanDeliveryResolver,
      'mobi': MobiDeliveryResolver,
      'sda': SdaDeliveryResolver,
      'quomi': QuomiDeliveryResolver,
    }
  }
}
